import axios from "axios";
import { AUTH_KEYS } from "../constants/storageKeys";

// --------------------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(AUTH_KEYS.TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add sessionId header for session tracking
    const sessionId = localStorage.getItem(AUTH_KEYS.SESSION_ID);
    if (sessionId) {
      config.headers["x-session-id"] = sessionId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    // Handle session terminated response
    if (error.response?.status === 401) {
      const message = error.response?.data?.message || "";
      if (message.includes("terminated") || message.includes("Session has been terminated")) {
        localStorage.removeItem(AUTH_KEYS.SESSION_ID);
        localStorage.removeItem(AUTH_KEYS.TOKEN);
        // Redirect to main app login
        window.location.href = process.env.REACT_APP_MAIN_APP_URL + "/public/auth/sign-in?reason=session_terminated";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

// --------------------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config = {}] = Array.isArray(args) ? args : [args, {}];

  try {
    const res = await axiosInstance.get(url, {
      ...config
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const poster = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.post(url, data, { ...config, withCredentials: true, });
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    }
  }
};

// --------------------------------------------------------------------------------

export const endpoints = {
  exam: {
    getExamRegistrationDetail: () =>
      `/userProductRegistration/getOngoingExamRegistration`,
    getOngoingExam: () =>
      `/exam/getOngoingExamWithDetails`,
    getWritingTest: (writingId) =>
      `/writing/${writingId}`,
  },
  readingUserAnswersUpdateBulk: "/readingUserAnswers/bulkUpdate",
  listeningUserAnswersUpdateBulk: "/listeningUserAnswers/bulkUpdate",
  writingUserAnswersUpdateBulk: "/writingUserAnswers/bulkUpdate",
  readingUserAnswers: "/readingUserAnswers",
  sessionDetails: (id) => `/sessions/getByUprId/${id}`,
  checkInstantResult: (uprId) => `/exam/checkInstantExamResult/${uprId}`,
  checkSectionPracticeResult: (productType, userProductRegistrationId) => `${productType}/checkExam/${userProductRegistrationId}`,
  getUserAnswers: (productType, userProductRegistrationId) => `${productType}/getByUprId/${userProductRegistrationId}`,
  createInstantExamSchedule: (uprId) => `instantExamSchedule/${uprId}`,
  getExam: (productİd) => `exam/${productİd}`,
};
